<template>
  <div class="hotel-standard">
    <div class="hotel-standard__label">Standard hotelu</div>
    <div class="hotel-standard__body checklist">
      <div v-for="item in value" v-if="item.id >= 30" :key="item.id" class="checklist-item">
        <CheckBox class="checklist-item__checkbox" v-model="item.selected" :enabled="item.enabled" />        
        <Rating v-model="item.id" @click="toggleSelected(item)" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CheckBox from '@/components/CheckBox.vue'
import Rating from '@/components/Rating.vue'

@Component({
  components: {
    CheckBox,
    Rating,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
})
export default class HotelStandard extends Vue {
  toggleSelected (item) {
    item.selected = !item.selected
  }
}
</script>

<style lang="scss" scoped>
@import '../filter.scss';

.hotel-standard {
  @include filter(#005CAA);

  &__body {
    @include filter-body(#009FEA);

    .rating:hover {
      cursor: pointer;
      color: #08c1fe;
    }

    > div {
      align-items: flex-start;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/HotelStandardDropdown.vue